import { render, staticRenderFns } from "./BurnoutConsulting.vue?vue&type=template&id=86355a28&scoped=true&"
import script from "./BurnoutConsulting.vue?vue&type=script&lang=js&"
export * from "./BurnoutConsulting.vue?vue&type=script&lang=js&"
import style0 from "./BurnoutConsulting.vue?vue&type=style&index=0&id=86355a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86355a28",
  null
  
)

export default component.exports